import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { cancelLiveAnswerRequested } from 'features/qa/actions';

export function* cancelLiveAnswerSaga(action: ReturnType<typeof cancelLiveAnswerRequested>) {
  yield call(SignalingSocket.send, {
    event: 'cancelLiveAnswerQuestion',
    data: {
      liveAnswerId: action.payload.liveAnswerId,
      questionId: action.payload.questionId,
    },
  });
}
